import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, IconButton, MenuItem, Popover, Switch, TextField, Tooltip } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

export const ColumnVisibilityMenu = ({ table, testIdPrefix = 'table', buttonTestId, onReset }) => {
  const [columnsAnchor, setColumnsAnchor] = useState(null);
  const [search, setSearch] = useState('');
  const columns = table.getAllLeafColumns();
  const filteredColumns = columns.filter(column =>
    column.columnDef.header.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Tooltip title="Show or hide columns">
        <IconButton
          size="small"
          onClick={event => setColumnsAnchor(event.currentTarget)}
          data-testid={buttonTestId || `${testIdPrefix}-column-visibility-button`}
        >
          <ViewColumnIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={columnsAnchor}
        open={Boolean(columnsAnchor)}
        onClose={() => setColumnsAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        marginThreshold={8}
        slotProps={{
          paper: {
            className: 'event-history-table__column-popover',
            'data-testid': `${testIdPrefix}-column-visibility-menu`,
          },
        }}
      >
        <div className="envDataSelectorGroup event-history-table__column-search">
          <div className="input-group-addon">
            <i className="fas fa-search" />
          </div>
          <TextField
            size="small"
            value={search}
            onChange={event => setSearch(event.target.value)}
            placeholder="Search..."
            onKeyDown={event => event.stopPropagation()}
            slotProps={{ htmlInput: { 'data-testid': `${testIdPrefix}-column-search-input` } }}
          />
          {onReset && (
            <Tooltip title="Reset columns to defaults">
              <IconButton
                size="small"
                className="event-history-table__column-reset"
                aria-label="Reset columns to defaults"
                onClick={onReset}
                data-testid={`${testIdPrefix}-column-reset-button`}
              >
                <RestartAltIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </div>
        {filteredColumns.map(column => {
          const columnKey = column.id || column.accessorKey;
          return (
            <MenuItem key={columnKey}>
              <FormControlLabel
                checked={column.getIsVisible()}
                disabled={!column.getCanHide()}
                onChange={() => column.toggleVisibility()}
                label={column.columnDef.header}
                control={(
                  <Switch
                    size="small"
                    slotProps={{ input: { 'data-testid': `${testIdPrefix}-column-toggle-${columnKey}` } }}
                  />
                )}
              />
            </MenuItem>
          );
        })}
      </Popover>
    </>
  );
};

ColumnVisibilityMenu.propTypes = {
  table: PropTypes.object.isRequired,
  testIdPrefix: PropTypes.string,
  buttonTestId: PropTypes.string,
  onReset: PropTypes.func,
};